import React from 'react';
import styled from 'styled-components';

import { largeUp } from '@dashboard/services/style';

const Box = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

const StyledBoxItem = styled.div`
  width: 100%;

  padding-left: 1em;
  padding-right: 1em;

  &:first-child {
    padding-left: 0;
  }

  ${largeUp`
  width: auto;
  padding-top: 0;
  padding-bottom: 0;
`};
`;

const BoxItem = props => (
  <StyledBoxItem className="lg:border-r lg:border-gray-100 lg:last:border-0" {...props} />
);

const BoxTitle = props => <div className="mb-1 text-gray-500" {...props} />;

const BoxContent = styled.div`
  margin-top: auto;
  margin-bottom: auto;
`;

export { Box, BoxItem, BoxTitle, BoxContent };
